// src/pages/BlogPage.jsx
import React, { useEffect, useState } from "react";
import ProductGridSkeleton from "../../skeletons/ProductGridSkeleton";
import { Link } from "react-router-dom";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(
          "https://tyka.premierhostings.com/beta/api/site-post-list"
        );
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();

        // API returns { data: [...] }
        setBlogs(data.data || []);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) return <ProductGridSkeleton />;

  return (
    <div className="container mx-auto px-4 py-6">
      <h2 className="text-2xl font-bold mb-6">All Blogs</h2>

      {blogs.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-400">No blogs available.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {blogs.map((blog) => {
            const imageUrl = blog.image
              ? `https://tyka.premierhostings.com/beta/storage/${blog.image}`
              : "https://via.placeholder.com/400x250?text=No+Image";

            return (
              <div
                key={blog.id}
                className="border rounded-lg overflow-hidden shadow hover:shadow-lg transition duration-300 bg-white dark:bg-gray-800"
              >
                {/* Blog Image */}
                <Link to={`/blogs/${blog.slug}`}>
                  <img
                    src={imageUrl}
                    alt={blog.title}
                    className="w-full h-52 object-cover"
                  />
                </Link>

                <div className="p-4">
                  {/* Blog Title */}
                  <Link to={`/blogs/${blog.slug}`}>
                    <h3 className="text-lg font-semibold mb-2 hover:text-red-600">
                      {blog.title}
                    </h3>
                  </Link>

                  {/* Blog Excerpt */}
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-3 line-clamp-3">
                    {blog.excerpt || "No excerpt available."}
                  </p>

                  {/* Author & Date */}
                  <div className="text-xs text-gray-500 dark:text-gray-400 flex justify-between">
                    <span>By {blog.author?.name || "Unknown"}</span>
                    <span>
                      {new Date(blog.created_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BlogPage;
